import { createSelector } from 'reselect';

export const renderingEnvSelector = state => state.renderingEnv || {};
export const componentsListSelector = createSelector(
  renderingEnvSelector,
  ({ supportedComponents }) => supportedComponents
);
export const renderingEnvNameSelector = createSelector(
  renderingEnvSelector,
  ({ renderingEnvName }) => renderingEnvName
);
